


import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import PersonIcon from '@mui/icons-material/Person';
import FollowersIcon from '@mui/icons-material/People';
import TaskIcon from '@mui/icons-material/Assignment'; // Import Task Icon
import ArrowBack from '@mui/icons-material/ArrowBack'; // Import ArrowBack Icon

const GetAllApplicants = () => {
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(true); // To manage loading state

  // Accessing campaignDetails from the state passed via useNavigate
  const location = useLocation();
  const { campaignDetails } = location.state || {}; // Get campaignDetails from state if available

  console.log("Campaign Details:", campaignDetails); // Log campaign details

  useEffect(() => {
    // Check if campaignDetails is available before making the request
    if (campaignDetails && campaignDetails._id) {
      // Dynamically use the campaign ID from campaignDetails
      const campaignId = campaignDetails._id;
      const apiUrl = `https://server-side-influencer.onrender.com/manager/applicants/${campaignId}`;
      
      // Fetching applicant data from the API
      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          console.log("API Response Data:", data); // Log the API response

          // Check if the data is an array before setting state
          if (Array.isArray(data)) {
            setApplicants(data); // Set the applicants state with the API data if it's an array
          } else {
            console.error("API returned data that is not an array:", data);
          }
          setLoading(false); // Set loading to false once data is fetched
        })
        .catch(error => {
          console.error("Error fetching applicants:", error);
          setLoading(false); // Set loading to false even in case of error
        });
    }
  }, [campaignDetails]); // Dependency array ensures effect is called when campaignDetails change

  const handleRemove = async (applicantRealId) => {
    try {
      console.log("Applicant Real ID to remove:", applicantRealId);
      const response = await fetch(
        `https://server-side-influencer.onrender.com/brand/delete/${applicantRealId}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        // Remove applicant from the state if deletion is successful
        setApplicants((prevApplicants) =>
          prevApplicants.filter((applicant) => applicant._id !== applicantRealId)
        );
      } else {
        console.error("Failed to delete applicant");
      }
    } catch (error) {
      console.error("Error deleting applicant:", error);
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Show loading text while data is being fetched
  }

  return (
    <div className="flex h-screen mb-0">
      <div className="h-screen ml-0 max-sm:ml-0 w-screen">
        {/* Header with Back button on the left and Applicants on the right */}
        <div className="w-full h-20 bg-white-800 text-white flex justify-between items-center px-4">
          {/* Back button aligned to the left */}
          <button onClick={() => window.history.back()} className="text-black">
            <ArrowBack /> Back {/* Material-UI Back Arrow Icon */}
          </button>

          {/* Applicants text aligned to the right */}
          <h1 className="text-1xl font-bold text-black ml-4">
            Applicants
          </h1>
        </div>

        <div className="h-screen ml-1 max-sm:ml-0 w-screen">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-center mb-6 text-black-600 ml-10">Applicants for this Campaign</h1>

            {/* Show "No applicants" message if no applicants */}
            {applicants.length === 0 ? (
              <div className="text-center text-xl text-gray-500">No applicants</div>
            ) : (
              <div className="overflow-x-auto ml-11">
                <table className="min-w-full table-auto border-collapse shadow-lg rounded-lg">
                  <thead>
                    <tr className="bg-gray-200 text-gray-700">
                      <th className="px-4 py-2 text-left">Profile Picture</th>
                      <th className="px-4 py-2 text-left">Name</th>
                      <th className="px-4 py-2 text-left">Age</th>
                      <th className="px-4 py-2 text-left">Followers</th>
                      <th className="px-4 py-2 text-left">Email</th>
                      <th className="px-4 py-2 text-left">Status</th>
                      <th className="px-4 py-2 text-left">Instagram</th>
                      <th className="px-4 py-2 text-left">Task Link</th>
                      <th className="px-4 py-2 whitespace-nowrap">Submitted Images</th>
                      <th className="px-4 py-2 text-left">Action</th> {/* Action Column for Remove */}
                    </tr>
                  </thead>
                  <tbody>
                    {applicants.map((applicant, index) => (
                      <tr key={index} className="border-b hover:bg-gray-100">
                        <td className="px-4 py-2">
                          <img
                            src={applicant.profilePic}
                            alt="Profile"
                            className="w-12 h-12 rounded-full object-cover"
                          />
                        </td>
                        <td className="px-4 py-2">{applicant.name}</td>
                        <td className="px-4 py-2">
                          <PersonIcon /> {applicant.age}
                        </td>
                        <td className="px-4 py-2">
                          <FollowersIcon /> {applicant.followers}
                        </td>
                        <td className="px-4 py-2">
                          <a href={`mailto:${applicant.email}`}>
                            <EmailIcon />
                          </a>
                        </td>
                        <td className="px-4 py-2">
                          <span
                            className={`px-2 py-1 rounded-full text-white ${
                              applicant.status === "selected"
                                ? "bg-green-500"
                                : "bg-red-500"
                            }`}
                          >
                            {applicant.status}
                          </span>
                        </td>
                        <td className="px-4 py-2">
                          <a href={applicant.instagramLink} target="_blank" rel="noopener noreferrer">
                            <InstagramIcon />
                          </a>
                        </td>
                        <td className="px-4 py-2">
                          <a href={applicant.taskLink} target="_blank" rel="noopener noreferrer">
                            <TaskIcon className="cursor-pointer text-blue-500" />
                          </a>
                        </td>

                        <td className="px-4 py-2">
                          {/* Render Submitted Images */}
                          {applicant.submittedImages && applicant.submittedImages.length > 0 && (
                            <div className="flex items-center space-x-2">
                              {applicant.submittedImages.map((image, index) => (
                                <a key={index} href={image} target="_blank" rel="noopener noreferrer">
                                  <img
                                    src={image}
                                    alt={`submitted-${index}`}
                                    className="w-10 h-10 object-cover rounded-lg border border-gray-300"
                                  />
                                </a>
                              ))}
                            </div>
                          )}
                        </td>
                        <td className="px-4 py-2">
                          <button
                            onClick={() => handleRemove(applicant._id)} // Adjusted here
                            className="px-4 py-2 bg-red-500 text-white rounded-full hover:bg-red-700"
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetAllApplicants;
